module.exports = __webpack_public_path__ + "img/infographic_top_colors.1f25e6f6.gif";